// 商品注意事項 上限、數量、時間
import dayjs from '@/common/dayjs';

interface Props {
    item: any;
    isDrawType: boolean;
}

const ItemAmount = ({ item, isDrawType }: Props) => {
    const {
        beginTime,
        endTime,
        remainingStock,
        stardustCost = 100,
        myTicketCount = 0,
        winnerCount = 0,
        redeemLimit = 1,
    } = item || {};

    // 剩餘數量顯示，null 代表沒有庫存限制，超過 999 也顯示無限符號
    const remainingStockText =
        remainingStock == null || remainingStock > 999 ? '∞' : remainingStock;

    const timeText = `${beginTime ? dayjs(beginTime).format('YYYY.MM.DD') : '不限'}~${
        endTime ? dayjs(endTime).format('YYYY.MM.DD') : '不限'
    }`;

    return (
        <div
            className="pt-5 border-t border-dashed border-black2 space-y-4 text-black8 text-btn1b
        *:between-center [&>p>span:last-of-type]:text-btn1 lg:pt-10"
        >
            <p>
                {isDrawType ? (
                    <>
                        <span>商品數量</span>
                        <span>{winnerCount}</span>
                    </>
                ) : (
                    <>
                        <span>兌換上限</span>
                        <span>每人限兌 {!redeemLimit ? '∞' : redeemLimit || 1} 次</span>
                    </>
                )}
            </p>
            {isDrawType ? (
                <p>
                    <span>星塵比例</span>
                    <span>{stardustCost}星塵可兌換 1 張抽獎券</span>
                </p>
            ) : (
                <p>
                    <span>剩餘數量</span>
                    <span>{remainingStockText}</span>
                </p>
            )}
            <p>
                {isDrawType ? (
                    <>
                        <span>截止時間</span>
                        <span>{timeText}</span>
                    </>
                ) : (
                    <>
                        <span>兌換時間</span>
                        <span>{timeText}</span>
                    </>
                )}
            </p>

            {isDrawType && (
                <p>
                    <span>此帳號已投入獎券</span>
                    <span>{myTicketCount}張</span>
                </p>
            )}
        </div>
    );
};

export default ItemAmount;
